'use strict';
document.getElementById('message-form').addEventListener('submit', function(event) {
    event.preventDefault();
});

//# sourceMappingURL=index.01ff7a4a.js.map
